import React, { FC, memo } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { IContactPerson } from "@/data/consultant-profiles";
import { formatFullName } from "@/data/persons";
import { formatPhone } from "@/data/phones";
import { Flex } from "@/eworkitComponents";

interface IContactPersonProps {
  contactPerson: IContactPerson;
  hasIcon?: boolean;
}

export const ContactPerson: FC<IContactPersonProps> = memo(({ contactPerson, hasIcon = true }) => {
  return (
    <Flex innerMargin="xs" direction="column" hjSuppress>
      <Flex innerMargin="sm">
        {hasIcon && <Icon color="grey2" icon="profile" size="md" />}
        <Text text={formatFullName(contactPerson)} />
      </Flex>

      <Flex innerMargin="sm">
        {hasIcon && <Icon color="grey2" icon="messages" size="md" />}
        <Text text={contactPerson.email} />
      </Flex>

      {contactPerson.phone && (
        <Flex innerMargin="sm">
          {hasIcon && <Icon color="grey2" icon="phone" size="md" />}
          <Text text={formatPhone(contactPerson.phone)} />
        </Flex>
      )}
    </Flex>
  );
});
